import TablePlugin from '@tiptap/extension-table'
import './Table.scss'

export const Table = TablePlugin.extend({
  addKeyboardShortcuts() {
    return {
      Tab: () => {
        return this.editor.commands.goToNextCell()
      },
      'Shift-Tab': () => {
        return this.editor.commands.goToPreviousCell()
      },
      'Mod-Shift-F': () => {
        // Log pour le debug
        console.log('Fixing tables')
        return this.editor.commands.fixTables()
      },
    }
  },
})

export const styleTables = (editorContent: string) => {
  const div = document.createElement('div')
  div.innerHTML = editorContent
  div.querySelectorAll('table').forEach((element) => {
    element.setAttribute(
      'style',
      'max-width: 100%; border: 1px solid black; border-spacing: 0; margin-top: 15px; margin-bottom: 15px',
    )
  })
  div.querySelectorAll('table td, table th').forEach((element) => {
    element.setAttribute('style', 'border: 1px solid black; border-spacing: 0; padding: 5px')
  })

  return div.innerHTML
}
